<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
        <path d="M4 18L20 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 12L20 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 6L20 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>
